import OliverText from "@builder/components/general/OliverText";
import TooltipElement from "@builder/components/general/Tooltip";
import { ActionBuilderType, getIconByType, getTitleByType } from "@builder/utils/actionBuilderHelpers";
import { RenderActionBuilderItem } from "@common/build/types";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const SingleIcon = ({ action, size }: { action: RenderActionBuilderItem; size: number }) => {

    return (
        <TooltipElement
             position="bottom"
            text={getTitleByType(action.type) || ""}
            translationPrefix="popup.actionBuilder."
        >
            <img width={size} height={size} src={getIconByType(action.type as ActionBuilderType)} />
        </TooltipElement>
    );
};

const ActionIconList = ({ actions }: { actions: RenderActionBuilderItem[] }) => {
    const { t } = useTranslation();
    const [totalAvailableWidth, setTotalAvailableWidth] = useState(200);
    const divRef = useRef<HTMLDivElement>(null);
    const iconSize = 32;
    useEffect(() => {
        const updateWidth = () => {
            if (divRef.current) {
                setTotalAvailableWidth(divRef.current.clientWidth);
            }
        };

        updateWidth();
    }, [divRef.current?.clientWidth]);

    const gap = 8;
    const reservedWidth = 150 - gap; // the width of the text "and x more" plus padding design asked for minus the gap

    const maxIcons = Math.floor((totalAvailableWidth - reservedWidth) / (iconSize + gap));

    const displayedIcons = actions.slice(0, maxIcons);
    const extraCount = actions.length - maxIcons;

    return (
        <div
            ref={divRef}
            className="action-icons-row"
            style={{
                gap: `${gap}px`
            }}
        >
            {displayedIcons.map(a => (
                <SingleIcon key={a.id} action={a} size={iconSize} />
            ))}
            {extraCount > 0 && (
                <OliverText text={`${t("popup.actionBuilder.and")} ${extraCount} ${t("popup.actionBuilder.more")}`} size="s" color="base-grey" />
            )}
        </div>
    );
};

export default ActionIconList;
